import {
    ImportacaoClientesActions,
    ImportacaoClientesActionsTypes,
} from "./importacaoClientesActions"
import {
    ImportacaoClientesInicial,
    ImportacaoClientesModel,
} from "../models/importacaoClientesModel"

export function importacaoClientesReducer(
    state: ImportacaoClientesModel,
    action: ImportacaoClientesActions
): ImportacaoClientesModel {
    switch (action.type) {
        case ImportacaoClientesActionsTypes.ATUALIZAR_CONTEUDO:
            return { ...state, conteudo: action.payload }
        case ImportacaoClientesActionsTypes.DEFINIR_RESULTADO:
            return { ...state, resultado: action.payload }
        case ImportacaoClientesActionsTypes.LIMPAR:
            return ImportacaoClientesInicial
        default:
            return state
    }
}
